import { createRouter, createWebHistory } from "vue-router";
import { constantRouterMap } from "@/config/router.config.js";
import { formatPageTitle, resolveRoutePageTitle } from "@/composables/usePageTitle.js";

const router = createRouter({
  history: createWebHistory(),
  routes: constantRouterMap
});

router.afterEach((to) => {
  document.title = formatPageTitle(resolveRoutePageTitle(to));
});

export default router;
